module.exports = __webpack_public_path__ + "img/origami_wings.eaae91be.jpg";